import { apiSlice } from '@/store/api/apiSlice';

export interface Mahadasha {
  planet: string;
  start: string;
  end: string;
}

export const mahadashaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMahadasha: builder.query<Mahadasha[], string>({
      query: (userId) => ({
        url: 'astrology/mahadasha',
        params: { userId },
      }),
    }),
  }),
});


export const { useGetMahadashaQuery } = mahadashaApi;
